import { isNil } from 'lodash-es'

import { CoverOptionItem, Quote } from '../../../../domain'

export const getCombinedCoverOptionItemView =
  (quote: Quote) =>
  (coverOptionItem: CoverOptionItem): CoverOptionItem => {
    const inactiveState =
      isNil(quote.requestedOptionalCovers[coverOptionItem?.coverOption]) ||
      isNil(coverOptionItem?.active)
        ? undefined
        : false

    return {
      ...coverOptionItem,
      active: coverOptionItem.active || inactiveState,
    }
  }
